const TEAM_BACKGROUNDS = [
  { company: "Google", logo: "/logos/google.png" },
  { company: "Babylon Health", logo: "/logos/babylon-health.png" },
  { company: "Meta", logo: "/logos/meta.png" },
  { company: "Microsoft", logo: "/logos/microsoft.png" },
];

function ShieldIcon() {
  return (
    <svg viewBox="0 0 32 32" fill="none" stroke="currentColor" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round">
      <path d="M16 2L4 8v8c0 7 5.1 13.5 12 15 6.9-1.5 12-8 12-15V8L16 2z" />
      <path d="M11 16l3 3 7-7" />
    </svg>
  );
}

function AgentIcon() {
  return (
    <svg viewBox="0 0 32 32" fill="none" stroke="currentColor" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round">
      <circle cx="16" cy="10" r="6" />
      <path d="M6 28c0-6 4.5-10 10-10s10 4 10 10" />
      <path d="M22 8l4-4M24 4h-4v4" opacity="0.5" />
    </svg>
  );
}

function GlobeIcon() {
  return (
    <svg viewBox="0 0 32 32" fill="none" stroke="currentColor" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round">
      <circle cx="16" cy="16" r="12" />
      <ellipse cx="16" cy="16" rx="5" ry="12" />
      <path d="M4 16h24" />
      <path d="M6 9h20M6 23h20" opacity="0.5" />
    </svg>
  );
}

const VALUES = [
  {
    icon: <ShieldIcon />,
    title: "You Own Your Data",
    desc: "Health data belongs to the person it describes. Full stop. We build systems where you hold the keys.",
  },
  {
    icon: <AgentIcon />,
    title: "AI as Your Advocate",
    desc: "Intelligent agents that work for you — analyzing, correlating, and surfacing insights across your entire health timeline.",
  },
  {
    icon: <GlobeIcon />,
    title: "Open Ecosystem",
    desc: "An open marketplace where health experts, researchers, and developers publish guides that anyone can install and run.",
  },
];

export function CompanyPage() {
  return (
    <div className="company-page">
      {/* Hero */}
      <section className="company-hero">
        <h1 className="company-hero-title">
          We&rsquo;re building the future of
          <br />
          <span className="company-hero-accent">personal health intelligence.</span>
        </h1>
        <p className="company-hero-subtitle">
          Kin is a startup on a mission to give every person true ownership of
          their health data — and the AI tools to make sense of it.
        </p>
      </section>

      {/* Photo */}
      <section className="company-photo-section">
        <div className="company-photo">
          <img
            src="https://images.unsplash.com/photo-1522071820081-009f0129c71c?w=1200&q=80&auto=format&fit=crop"
            alt="Team collaborating at a table"
            loading="eager"
          />
        </div>
      </section>

      {/* Team background */}
      <section className="company-team-section">
        <h2 className="company-section-heading">
          Built by people who&rsquo;ve shipped at scale.
        </h2>
        <p className="company-section-desc">
          Our team brings deep experience from some of the world&rsquo;s leading
          technology and health companies.
        </p>
        <div className="company-logos-row">
          {TEAM_BACKGROUNDS.map((t) => (
            <img
              key={t.company}
              className="company-logo-img"
              src={t.logo}
              alt={t.company}
            />
          ))}
        </div>
      </section>

      {/* Values */}
      <section className="company-values-section">
        <h2 className="company-section-heading">What we believe</h2>
        <div className="company-values-grid">
          {VALUES.map((v) => (
            <div key={v.title} className="company-value-card">
              <div className="company-value-icon">{v.icon}</div>
              <h3 className="company-value-title">{v.title}</h3>
              <p className="company-value-desc">{v.desc}</p>
            </div>
          ))}
        </div>
      </section>

      {/* CTA */}
      <section className="company-cta">
        <h2 className="company-cta-heading">
          Interested in what we&rsquo;re building?
        </h2>
        <p className="company-cta-desc">
          We&rsquo;re hiring engineers, designers, and health domain experts who
          share our vision.
        </p>
        <a href="#" className="company-cta-btn">
          Get in Touch
        </a>
      </section>
    </div>
  );
}
